import * as React from 'react';
import { GeoLocationModalDesktop } from '../../../../../components/packages/GeoLocation';
import { useSelector } from 'react-redux';
import { getRegion } from '../../../../../selectors/filters/getRegion';
import { GeoLocationSuggestFieldContainer } from '../GeoLocationSuggestFieldContainer';
import { getGeo } from '../../../../../selectors/geo';
import { useHandleReloadPopularRegions } from '../../utils';
import { IGeoLocationContainerProps } from '../../types';
import { SPECIAL_REGIONS } from '../../../../../constants/regions';

export function GeoLocationModalContainerDesktop(props: IGeoLocationContainerProps) {
  const { isOpen, onClose, onSelectRegion, title } = props;
  const { locations, isError, isFetching } = useSelector(getGeo);
  const selectedRegion = useSelector(getRegion);
  const handleRetry = useHandleReloadPopularRegions();

  return (
    <GeoLocationModalDesktop
      title={title}
      isError={isError}
      isLoading={isFetching}
      isOpen={isOpen}
      onClose={onClose}
      locations={locations}
      specialRegions={SPECIAL_REGIONS}
      onLocationSelect={onSelectRegion}
      searchComponent={<GeoLocationSuggestFieldContainer onLocationChange={onSelectRegion} />}
      selectedLocation={selectedRegion}
      onRetry={handleRetry}
    />
  );
}
